// extracted by mini-css-extract-plugin
module.exports = {"cell":"DateCell_cell__26EGG","icon":"DateCell_icon__YXpt9"};